import { useState } from 'react'

/**
 * useIsTouchOnlyDevice
 *
 * Detects whether the user is on a touch-only device (touch input without hover capability).
 *
 * - This will return `false` for devices that have both touch and hover (e.g., laptops with touchscreens,
 *   tablets with mouse/trackpad, or hybrid devices). These devices support hover via their pointing device,
 *   so they should use hover-based interactions rather than touch-only interactions.
 * - This will return `true` for devices like phones and tablets that are primarily touch-only.
 *
 * Detection happens synchronously on first render and never changes.
 *
 * @returns Boolean indicating if the device is touch-only (no hover capability)
 */
export function useIsTouchOnlyDevice() {
  const [isTouchOnlyDevice] = useState(() => typeof window !== 'undefined' && window.matchMedia('(hover: none) and (pointer: coarse)').matches)

  return isTouchOnlyDevice
}
